module.exports = __webpack_public_path__ + "img/2020-SFWSC-Silver.5b545dfe.png";